import { ReportDashboardComponentViewMode } from '@core/reports-types';
import type {
  ReportDashboardComponentViewData,
  ReportComponentGridProps,
  ReportComponentGridPropsDecorated,
} from '@core/reports-types';

const clamp = (value: number, min: number, max: number = Number.POSITIVE_INFINITY): number =>
  Math.min(Math.max(min, value), max);

export const getVisualizationGridConstraints = (
  component: Pick<ReportDashboardComponentViewData, 'viewMode' | 'secondaryGroup'>,
  props: ReportComponentGridProps,
): Omit<ReportComponentGridPropsDecorated, 'x' | 'y'> => {
  switch (component.viewMode) {
    case ReportDashboardComponentViewMode.Chart: {
      // default size of Chart type rows and cols
      const minItemRows = 2;
      const maxItemRows = 4;
      const minItemCols = 4;

      return {
        minItemRows,
        maxItemRows,
        minItemCols,
        rows: clamp(props.rows, 2, maxItemRows),
        cols: clamp(props.cols, minItemCols),
      };
    }

    case ReportDashboardComponentViewMode.Table: {
      // pivot table
      if (component.secondaryGroup) {
        // default size of PivotTable type rows and cols
        const minItemRows = 2;
        const maxItemRows = 6;
        const minItemCols = 6;

        return {
          minItemRows,
          maxItemRows,
          minItemCols,
          rows: clamp(props.rows, minItemRows, maxItemRows),
          cols: clamp(props.cols, minItemCols),
        };
      }
      // default size of Table type rows and cols
      const minItemRows = 2;
      const maxItemRows = 4;
      const minItemCols = 3;

      return {
        minItemRows,
        maxItemRows,
        minItemCols,
        rows: clamp(props.rows, minItemRows, maxItemRows),
        cols: clamp(props.cols, minItemCols),
      };
    }

    case ReportDashboardComponentViewMode.Summary: {
      // default size of Summary type rows and cols
      const minItemRows = 1;
      const maxItemRows = 4;
      const minItemCols = 2;

      return {
        minItemRows,
        maxItemRows,
        minItemCols,
        rows: clamp(props.rows, minItemRows, maxItemRows),
        cols: clamp(props.cols, minItemCols),
      };
    }

    default:
      return { rows: props.rows, cols: props.cols };
  }
};
